<template>
    <ol class="Wizard List__unstyled">
        <li class="top" v-for="(label, index) in labels"
            v-bind:key="label"
            v-bind:class="{ 'js-active' : index===activeNode , 'js-complete' : index < activeNode  }" tabindex="-1">
            <span>{{ label }}</span>
        </li>
    </ol>
</template>

<script>
    import { nextTick, onMounted } from 'vue';

    export default {
        props: {
            labels: Array,
            activeNode: Number
        },
        watch: {
            activeNode: (val) => {
                var el = document.getElementsByClassName('top')[0];
                el.focus();
            }
        },
        setup() {
            onMounted(() => {
                nextTick(() => {
                    var el = document.getElementsByClassName('top')[0];
                    el.focus();
                })
            });
        }
    }
</script>


<style lang="scss" scoped>
    @import "~styles/base/variables";
    @import "~styles/vendor/include-media";

    li:focus {
        outline: none;
    }

    .Wizard {
        display: flex;
        position: relative;

        &::before {
            background-color: $brand-color-alternate;
            content: "";
            font-size: 0.46875rem;
            height: 1em;
            left: 0;
            position: absolute;
            top: 0.5em;
            width: 100%;
            z-index: -1;
        }

        > li {
            flex-basis: 0;
            flex-grow: 1;
            flex-shrink: 0;
            text-align: center;
            text-transform: uppercase;

            > span {
                display: block;
                opacity: 1.0;
                padding: 0 $gutter;
                transition: opacity 0.2s ease;
            }

            &::before {
                background-color: $brand-color-alternate;
                border-radius: 100%;
                content: "";
                display: block;
                font-size: 0.9375rem;
                height: 1em;
                margin: 0 auto 0.6875rem;
                transition: box-shadow 0.2s ease-in-out;
                width: 1em;
            }
            // Current
            // -------

            &.js-active {

                &::before {
                    box-shadow: 0 0 0 0.375rem $brand-color-primary;
                }

                > span {
                    opacity: 1;
                }
            }
            // Completed
            // ---------

            &.js-complete {

                &::before {
                    background-color: $brand-color-primary;
                }

                > span {
                    opacity: 1;
                }
            }

            @include media("<720px") {
                // position: relative;

                > span {
                    // left: 50%;
                    //position: absolute;
                    // transform: translateX(-50%);
                    width: 100%;
                    white-space: nowrap;
                    // visibility: hidden;
                    display: none;
                }

                &:last-child {
                    > span {
                        //right: 0;
                    }
                }

                &.js-active {

                    > span {
                        //visibility: visible;
                        display: block;
                    }
                }
            }
        }
    }
</style>
